<template>
	<div>
		<h2 class="font-semibold text-center text-heading-primary md:text-left md:text-xl mb-4">
			Aplikace Můj Globus
		</h2>
		<div class="flex gap-2 sm:gap-4 justify-center md:justify-start flex-wrap sm:flex-nowrap">
			<a href="https://apps.apple.com/cz/app/m%C5%AFj-globus/id1425012509?l=cs" target="_blank" rel="noopener noreferrer" class="focus-outline">
				<NuxtPicture
					quality="100"
					format="webp"
					loading="lazy"
					src="/images/app-store-2.png"
					alt="App Store"
					:img-attrs="{class: 'lg:h-10'}"
					sizes="134px"
				/>
			</a>
			<a href="https://play.google.com/store/apps/details?id=com.pragonauts.globus&hl=cs" target="_blank" rel="noopener noreferrer" class="focus-outline">
				<NuxtPicture
					quality="100"
					format="webp"
					loading="lazy"
					src="/images/google-play-2.png"
					alt="Google Play"
					:img-attrs="{class: 'lg:h-10'}"
					sizes="134px"
				/>
			</a>
		</div>
	</div>
</template>
